import React, { Component } from "react"

import Button from "../button-v2/anchor"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null

class YouVisit extends Component {
  componentDidMount() {
    if (postscribe) {
      postscribe(
        document.body,
        `<script
        async="async"
        defer="defer"
        src="https://www.youvisit.com/tour/Embed/js3"
      ></script>`
      )
    }
  }

  render() {
    return (
      <div>
        {this.props.you_visit_hyperlink && (
          <Button
            link={`https://www.youvisit.com/#/vte/?${this.props.you_visit_hyperlink}`}
            className={this.props.className}
            label={this.props.label}
            accessibilityLabel={this.props.accessibilityLabel}
            icon={this.props.icon}
            variant={this.props.variant}
            spacing={this.props.spacing}
          />
        )}
      </div>
    )
  }
}

export default YouVisit
